import React from 'react';
import { SitesList } from './SitesList';
import useSitesPage from '@/hooks/SitesPage/useSitesPage';
import { useIsDMAdmin } from '@/hooks';
import { RefreshCwIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { NoResults } from '@/assets/Icons';
import { Icon } from '@/components/shared/display/Icon';

const SitesEmptyFallback = () => {
  return (
    <div className="min-h-[calc(100%-30px)] border-8 flex-1 bg-white dark:bg-[#52606d] my-[-0.5rem] rounded-xl flex flex-col items-center justify-center border-gray-200 dark:border-gray-700">
      <Icon icon={NoResults} className="w-16 h-16" />
      <div className="text-sm">No Sites Found</div>
    </div>
  );
};

export const Sites = () => {
  const { isLoading, data, getSitesData } = useSitesPage();

  return (
    <>
      <div className="w-full h-full">
        {isLoading && (
          <div className="w-100 h-[40dvh] xl:h-[80vh] rounded-xl">
            <Skeleton className="w-full h-full" />
          </div>
        )}
        {!isLoading && !!data?.length && <SitesList sitesData={data} />}
        {!isLoading && !data?.length && <SitesEmptyFallback />}
      </div>
    </>
  );
};
